<template>
  <div class="container">
    <h4 class="title is-4">2FA</h4>
    <div class="container has-text-left">
      <b-table
          v-if="tableData.length > 0"
          :narrowed="true"
          :striped="true"
          :data="tableData"
          ref="table"
          detailed
          detail-key="id"
          @click="handleClickRow"
      >
        <template slot-scope="props">
          <b-table-column field="num" class="is-hidden-mobile" numeric>{{props.row.num}}</b-table-column>
          <b-table-column field="name" label="Name">{{props.row.name}}</b-table-column>
          <b-table-column field="token" label="Code" numeric>
            <b-button type="is-success" class="is-small" @click.stop="handleClickGetToken(props.row.id)">Get Code</b-button>
            <span style="margin-left: 1.5rem">
              {{props.row.token}}
            </span>
          </b-table-column>
        </template>

        <template slot="detail" slot-scope="props">
          <div>
            <div>Account: {{props.row.account}}</div>
            <div v-if="props.row.url">URL: <a :href="props.row.url" target="_blank" rel="noopener noreferrer">{{props.row.url}}</a></div>
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

  export default {
    components: {

    },
    name: "screen2fa",
    data() {
      return {

      };
    },
    computed: {
      ...mapGetters('twofactor', ['accounts']),
      tableData() {
        const ret = [];

        if (this.accounts) {
          let num = 0;
          this.accounts.forEach(item => {
            num += 1;
            const hftToken = item.token.length > 0 ? item.token : '-';
            ret.push({
              ...item,
              token: hftToken,
              num,
            });
          });
        }

        return ret;
      }
    },
    methods: {
      ...mapActions('twofactor', ['getToken']),
      handleClickRow(row) {
        this.$refs.table.toggleDetails(row);
      },
      handleClickGetToken(id) {
        this.getToken({
          id,
        });
      }
    },
    mounted() {

    },
    unmounted() {

    }
  }
</script>

<style scoped>

</style>
